const state = {
  userInfo: {},
  shareInfo:{}
}

const mutations = {
  setUserInfo(state,userInfo){
    state.userInfo = userInfo
  },
  setShareInfo(state,shareInfo){
    state.shareInfo = shareInfo
  }
}

const actions = {
  someAsyncTask ({ commit }) {
    // do something async
    commit('INCREMENT_MAIN_COUNTER')
  }
}

export default {
  state,
  mutations,
  actions
}
